/* istanbul ignore file */
import { createContext, useContext} from 'react';

export const InteractionContext = new createContext();

export const useInteractionContext = () => {
    return useContext(InteractionContext);
}
